import { render, staticRenderFns } from "./external-link-dialog.vue?vue&type=template&id=ff97e9aa&scoped=true&"
import script from "./external-link-dialog.vue?vue&type=script&lang=js&"
export * from "./external-link-dialog.vue?vue&type=script&lang=js&"
import style0 from "./external-link-dialog.vue?vue&type=style&index=0&id=ff97e9aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff97e9aa",
  null
  
)

export default component.exports